import React from 'react';
import PropTypes from 'prop-types';

const DocumentNormalSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 16}`}
      height={`${height || 16}`}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66634 4H9.33301C10.6663 4 10.6663 3.33333 10.6663 2.66666C10.6663 1.33333 9.99967 1.33333 9.33301 1.33333L6.66634 1.33333C5.99967 1.33333 5.33301 1.33333 5.33301 2.66666C5.33301 4 5.99967 4 6.66634 4Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"/>
      <path
        d="M10.6667 2.67999C12.8867 2.79999 14 3.61999 14 6.66666V10.6667C14 13.3333 13.3333 14.6667 10 14.6667H6C2.66667 14.6667 2 13.3333 2 10.6667L2 6.66666C2 3.62666 3.11333 2.79999 5.33333 2.67999"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

DocumentNormalSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default DocumentNormalSvg;
